import styles from '../../../pages/ProductSelection.module.css';
import useProductSelectionStore from '../../../stores/useProductSelectionStore';

const PhotoNavigation = ({ isHoveringImage }) => {
  const { photos, productType, photosLoadingMessage, selectedPhoto, handleSelectedPhoto} = useProductSelectionStore();

  if (photosLoadingMessage || photos.length <= 1 || productType === 'default') {
    return null;
  }


  // Navigate photo (left/right)
  const navigatePhoto = (direction) => {
    if (!selectedPhoto?.id || photos.length === 0) return;

    const currentIndex = photos.findIndex(photo => photo.id === selectedPhoto.id);
    let newIndex;

    if (direction === 'left') {
      newIndex = currentIndex <= 0 ? photos.length - 1 : currentIndex - 1;
    } else {
      newIndex = currentIndex >= photos.length - 1 ? 0 : currentIndex + 1;
    }

    handleSelectedPhoto(photos[newIndex]);

  }
  return (
    <>
      <button 
        type="button"
        onClick={() => navigatePhoto('left')}
        aria-label="Previous images"
        className={`${styles.navArrowBase} ${styles.navArrowLeft} ${isHoveringImage ? styles.navArrowVisible : styles.navArrowHidden}`}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 256 256">
          <path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"/>
        </svg>
      </button>

      <button 
        type="button"
        onClick={() => navigatePhoto('right')}
        aria-label="Next images"
        className={`${styles.navArrowBase} ${styles.navArrowRight} ${isHoveringImage ? styles.navArrowVisible : styles.navArrowHidden}`}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 256 256">
          <path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"/>
        </svg>
      </button>
    </>
  );
};

export default PhotoNavigation;